export function capitalizeAllFirstLetters(s) {
    return s
        .split(/\s+/g)
        .map(portion => {
            return portion.charAt(0).toUpperCase() + portion.slice(1);
        })
        .join(" ");
}

export function hashCode(str) {
    let hash = 0;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
        const character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}

export function truncateString(s, numCharacters) {
    if (s.length <= numCharacters) {
        return s;
    }
    return s.substring(0, numCharacters) + "...";
}



// WEBPACK FOOTER //
// ./src/helpers/string.js